<template>
  <div class="manage-menu-popup">
    <b-modal
      id="manageMenu"
      centered
      size="lg"
      v-model="show"
      no-close-on-backdrop
    >
      <template #modal-header>
        <div class="manage-menu-popup-header text-center">
          <h4>Manage Menu</h4>
          <b-button variant="close-btn" class='btn-container' @click="closeModal">
            <i class="fas fa-times"></i>
          </b-button>
        </div>
      </template>
      <b-container fluid>
        <div class="manage-menu-popup-form">
          <!-- <ValidationObserver ref="observer" v-slot="{ handleSubmit }"> -->
          <!-- <form @submit.prevent="handleSubmit(submit)"> -->
          <input-text
            label-name="Title"
            label-for="title"
            :vmodel.sync="form.name"
            form-group-class="form-group mb-3"
            input-class="custom-input"
            :rules="{ required: true }"
            :readonly="true"
            :api-errors="apiErrors"
          />
          <label
            >Select Reps
            <span v-if="showSpinner">
              <spinner-grow :styles="spinnerStyles" />
            </span>
            <span v-else class="clr-theme"
              >(
              {{
                `${sendRepMessageSelectedReps.length} ${
                  sendRepMessageSelectedReps.length > 0 ? "Rep's" : "Rep"
                } Selected`
              }}
              )</span
            ></label
          >
          <rep-tree
            :downline-list="downlineList"
            :checkRepTree="checkRepTree"
            @onRepTreeUpdate="handleTreeUpdate"
          />
          <div class="form-group mb-3 pt-3 text-center">
            <button class="addBtn" @click="submit">Update Menu</button>
          </div>
          <!-- </form> -->
          <!-- </ValidationObserver> -->
        </div>
      </b-container>
    </b-modal>
  </div>
</template>
<script>
import RepTree from '@/components/RepTree/RepTree.vue'
import SpinnerGrow from "../../../components/ui/SpinnerGrow.vue";
import { mapGetters } from "vuex";
import Api from "@/resource/Api";

const form = {
  name: "",
  agents: [],
};
export default {
  props: {
    row: {
      required: true,
    },
  },
  components: {
    SpinnerGrow, RepTree
  },
  data: () => ({
    show: false,
    form: { ...form },
    isLoading: false,
    apiErrors: null,
    downlineList: null,
    checkRepTree: false,
    showSpinner: false,
    spinnerStyles: {
      width: "4px",
      height: "4px",
      background: "#0cf",
    },
  }),
  computed: {
    ...mapGetters({
      sendRepMessageSelectedReps: "sendRepMessageSelectedReps",
      sendRepMessageCheckedRep: "sendRepMessageCheckedRep",
    }),
  },
  methods: {
    closeModal() {
      this.form = { ...form };
      this.$store.commit("setSendRepMessageSelectedReps", []);
      this.$store.commit("setSendRepMessageCheckedRep", false);
      this.checkRepTree = false;
      this.$emit("update:row", {});
      this.$bvModal.hide("manageMenu");
    },
    submit() {
      let loader = this.$loading.show();
      let formData = {
        rep_menu_id: this.row.id,
        agents: this.sendRepMessageSelectedReps,
        is_all: this.form.agents[0] == "all" ? 1 : 0,
      };
      Api.put("v2/rep/hide-menu", formData)
        .then((res) => {
          this.$notify(res.data.message);
          this.$emit("onSuccess");
          this.closeModal();
        })
        .catch((err) => {
          this.errorResponse(err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    errorResponse(error) {
      if (error.response.status == 422) {
        this.apiErrors = { ...error.response.data.errors };
        setTimeout(() => {
          this.apiErrors = null;
        }, 5000);
      } else {
        this.$notify(error.response.data.message, "error");
      }
    },
    async getDownlineList() {
      const agentId = this.$store.getters.vipUser ? 20 : this.$store.getters.repId;
      let url = `v2/get-rep-tree?agent_id=${agentId}`;
      let loader = this.$loading.show();
      await Api.get(url)
        .then((res) => {
          this.downlineList = res.data.data;
        })
        .catch(() => (this.downlineList = {}))
        .finally(() => {
          loader.hide();
        });
    },
    handleTreeUpdate(status) {
      this.showSpinner = status;
    },
  },
  created() {
    this.getDownlineList();
  },
  watch: {
    row: {
      handler: function (row) {
        this.form["name"] = row.title;
        if (row && row.hidden_menu_agents) {
          this.$store.commit(
            "setSendRepMessageSelectedReps",
            row.hidden_menu_agents.map((item) => item.id)
          );
        }
        this.checkRepTree = true;
      },
    },
  },
};
</script>

<style scoped>
.clr-theme {
  color: #03c3ec;
}
</style>
<style>
.modal-header {
  justify-content: center;
  border: 0;
  padding: 25px 0;
  position: relative;
}
.modal-footer {
  display: none;
}
.manage-menu-popup-header button {
  position: absolute;
  top: -15px;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.modal-content {
  border: 0;
  border-radius: 15px;
}
.manage-menu-popup-header h4 {
  font-size: 20px;
  color: #2c3f58;
  font-weight: 600;
  margin: 0;
}
.addBtn {
  background: #03c3ec;
  border-radius: 6px;
  color: #fff;
  outline: none;
  border: 0;
  padding: 10px 0;
  margin-top: 10px;
  transition: all 0.6s ease;
  padding: 10px 50px;
}
div.multiselect {
  margin-left: 0 !important;
  width: 100% !important;
}
.manage-menu-popup-form label {
  margin-bottom: 6px;
  font-size: 14px;
  display: block;
}

.manage-menu-popup-header .btn-container  {
  position: absolute;
  top: -14px !important;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
</style>